(() => {
  const elem = document.createElement('div');
  const referenceElem = document.createElement('div');
  const measureElem = document.createElement('div');
  Object.assign(elem.style, {
    position: 'absolute',
    width: '100%',
    visibility: 'hidden',
  });
  Object.assign(referenceElem.style, {
    overflow: 'scroll',
    width: '50px',
  });
  elem.appendChild(referenceElem);
  referenceElem.appendChild(measureElem);

  const determineWidth = () => {
    const scrollBarWidth = 50 - measureElem.offsetWidth;

    window.swinger.storage.set('swinger.scrollbar-width', scrollBarWidth, true);
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
  };

  window.swinger.observer.initialize('body', (body) => {
    body.appendChild(elem);
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(determineWidth);
      resizeObserver.observe(elem);
    }

    const scrollBarWidth = window.swinger.storage.get('swinger.scrollbar-width', true);

    if (scrollBarWidth !== null) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
    } else {
      window.requestAnimationFrame(() => determineWidth);
    }
  }, false);
})();
